module.exports = __webpack_public_path__ + "img/weixingxuanju09314-2.prt.811579b6.jpg";